module.exports = __webpack_public_path__ + "static/media/promulgation-landing-animation.b1ee709a.png";